/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanBacklogGroupEnum {
  NoTeam = 'no-team',
  NoDate = 'no-date',
  NotSold = 'not-sold'
}
